import { useEffect, useState } from 'react'

// Sub-pixel scroll positions on zoomed or high-density screens never land exactly on an edge.
const EDGE_TOLERANCE_PX = 4

/** Whether a vertical scroller has content hidden above or below, for fading those edges. */
export const useScrollEdges = () => {
  const [scroller, setScroller] = useState<HTMLElement | null>(null)
  const [content, setContent] = useState<HTMLElement | null>(null)
  const [edges, setEdges] = useState({ atStart: true, atEnd: true })

  useEffect(() => {
    if (scroller == null) return

    const measure = () => {
      const atStart = scroller.scrollTop <= EDGE_TOLERANCE_PX
      const atEnd = scroller.scrollTop + scroller.clientHeight >= scroller.scrollHeight - EDGE_TOLERANCE_PX
      setEdges((current) => (current.atStart === atStart && current.atEnd === atEnd ? current : { atStart, atEnd }))
    }

    measure()
    scroller.addEventListener('scroll', measure, { passive: true })
    // Overflow also changes without a scroll: the window resizes, or items arrive once access has loaded.
    const observer = new ResizeObserver(measure)
    observer.observe(scroller)
    if (content != null) observer.observe(content)

    return () => {
      scroller.removeEventListener('scroll', measure)
      observer.disconnect()
    }
  }, [scroller, content])

  return { setScroller, setContent, ...edges }
}
